import React from 'react';

interface PublicPageProps {
  children: React.ReactNode;
  className?: string;
}

const PublicPage: React.FC<PublicPageProps> = ({ children, className = '' }) => (
  <div className={`min-h-screen bg-slate-50 ${className}`}>
    <div className="mx-auto max-w-7xl px-4 pb-20 pt-28 sm:px-6 lg:px-8">
      {children}
    </div>
  </div>
);

export default PublicPage;
